import { render, staticRenderFns } from "./fortuneTask.vue?vue&type=template&id=1f1dcd86&scoped=true&"
import script from "./fortuneTask.vue?vue&type=script&lang=js&"
export * from "./fortuneTask.vue?vue&type=script&lang=js&"
import style0 from "./fortuneTask.vue?vue&type=style&index=0&id=1f1dcd86&prod&scoped=true&lang=scss&"
import style1 from "./fortuneTask.vue?vue&type=style&index=1&id=1f1dcd86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1dcd86",
  null
  
)

export default component.exports